/**
 * Templates the invitation can be drawn with — their sections in drawing order
 * and the lines a couple may rewrite.
 *
 * Plain data, no components, so the app's parity test can import it: it must
 * agree with api/constants/invitation.mjs (what the API stores and validates)
 * and app/src/services/invitation/invitationRegistry.ts (the editor). The
 * components that draw each template live beside it in templates/.
 *
 * A text slot left unset shows its translated default (`i18nKey`, with the
 * event type as i18next context when `eventTypeContext` is set).
 */

export const DEFAULT_TEMPLATE = "classic";

export const TEXT_SLOTS = Object.freeze({
  invitationTitle: Object.freeze({
    max: 120,
    multiline: false,
    i18nKey: "venues.invitation.defaultTitle",
    eventTypeContext: true,
  }),
  invitationSubtitle: Object.freeze({
    max: 400,
    multiline: true,
    i18nKey: "venues.invitation.defaultSubtitle",
    eventTypeContext: true,
  }),
  interludeHeading: Object.freeze({ max: 120, multiline: false, i18nKey: "home.story.heading" }),
  interludeBody: Object.freeze({ max: 400, multiline: true, i18nKey: "home.story.description" }),
  quoteHeading: Object.freeze({ max: 120, multiline: false, i18nKey: "home.testimonial.heading" }),
  quoteText: Object.freeze({ max: 300, multiline: true, i18nKey: "home.testimonial.text" }),
  momentsHeading: Object.freeze({ max: 40, multiline: false, i18nKey: "home.gallery.heading" }),
  momentsQuote: Object.freeze({ max: 200, multiline: true, i18nKey: "home.gallery.quote" }),
  momentsSubtitle: Object.freeze({ max: 400, multiline: true, i18nKey: "home.gallery.subtitle" }),
  momentsButton: Object.freeze({ max: 40, multiline: false, i18nKey: "home.gallery.button" }),
});

export const TEMPLATES = Object.freeze({
  classic: Object.freeze({
    sections: Object.freeze([
      Object.freeze({ key: "hero", toggleable: false }),
      Object.freeze({ key: "invitation", toggleable: false }),
      Object.freeze({ key: "participants", toggleable: true }),
      Object.freeze({ key: "interlude", toggleable: true }),
      Object.freeze({ key: "story", toggleable: true }),
      Object.freeze({ key: "quote", toggleable: true }),
      Object.freeze({ key: "venues", toggleable: false }),
      Object.freeze({ key: "schedule", toggleable: false }),
      Object.freeze({ key: "moments", toggleable: true }),
      Object.freeze({ key: "gifts", toggleable: true }),
      Object.freeze({ key: "rsvp", toggleable: false }),
    ]),
    texts: Object.freeze({
      invitationTitle: "invitation",
      invitationSubtitle: "invitation",
      interludeHeading: "interlude",
      interludeBody: "interlude",
      quoteHeading: "quote",
      quoteText: "quote",
      momentsHeading: "moments",
      momentsQuote: "moments",
      momentsSubtitle: "moments",
      momentsButton: "moments",
    }),
  }),
});

/** The template an invitation payload asks for, or the default one. */
export const templateIdOf = (invitation) =>
  invitation?.template && Object.hasOwn(TEMPLATES, invitation.template)
    ? invitation.template
    : DEFAULT_TEMPLATE;
